export default "__VITE_ASSET__BSGKFJLn__"